import React from "react"
import { useTranslation } from "react-i18next"

const SideNavForgotPasswordCheckMailSection = props3 => {
  const { t } = useTranslation()

  return (
    <div
      className="side-nav-user-wrapper container px-7 justify-content-center"
      id="school-wrapper"
    >
      <div className="reset-pass-image"></div>
      <div className="side-nav-user-info f-js reset-pass-info">
        <div className="reset-pass-text">
          <div className="reset-pass-title">{t("main.sideNav.checkEmail")}</div>
          <div className="reset-pass-main-text">
            {t("main.sideNav.resetPassword")} {props3.userEmailForPassReset}
          </div>
        </div>
        <div
          id="backSchool"
          className="form-field login-button thanks-btn"
          onClick={props3.backFunction3}
        >
          {t("main.sideNav.thanks")}
        </div>
      </div>
    </div>
  )
}
export default SideNavForgotPasswordCheckMailSection
